export default {
  ADD_NOTIFICATION: 'ADD_NOTIFICATION',
  REMOVE_NOTIFICATION: 'REMOVE_NOTIFICATION',
  SET_CURRENT_TENANT: 'SET_CURRENT_TENANT',
  SET_TENANTS: 'SET_TENANTS',
  SET_USER: 'SET_USER',
};
